import { ObligationRulesFrequency } from '@commenda/prisma';
import { fetcher } from '@commenda/utils';

interface UpdateCustomComplianceItemRequest {
  dueDate?: string;
  isCustom?: boolean;
  complianceType?: string;
  customFields?: {
    explicitTitle: string;
    customFrequency?: ObligationRulesFrequency;
    customCategory?: string;
  };
}

export async function updateCustomComplianceItem(
  complianceItemId: string,
  data: UpdateCustomComplianceItemRequest
): Promise<Response> {
  const res: Response = await fetcher(
    `compliance/${complianceItemId}/custom`,
    {
      method: 'PUT',
      body: data,
    }
  );
  return res;
}
